var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-list-management',{ref:"baseListManagementRef",attrs:{"configData":_setup.configDataList}})
}
var staticRenderFns = []

export { render, staticRenderFns }